export default "/react/logoTeletype-f40b396d.png";